import { render, staticRenderFns } from "./PainelAnexoVisualizacao.vue?vue&type=template&id=685f9ee8&scoped=true"
import script from "./PainelAnexoVisualizacao.vue?vue&type=script&lang=js"
export * from "./PainelAnexoVisualizacao.vue?vue&type=script&lang=js"
import style0 from "./PainelAnexoVisualizacao.vue?vue&type=style&index=0&id=685f9ee8&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685f9ee8",
  null
  
)

export default component.exports